import { createAsyncThunk } from '@reduxjs/toolkit';
import regionService from './Region.service';
import { RegionFetchParams } from './Region.type';

export const getRegionListThunk = createAsyncThunk(
  'region/getRegionListThunk',
  async (params: RegionFetchParams, thunkAPI) => {
    const response = await regionService.getList(params);
    return response.data;
  },
);

export const getRegionByIdThunk = createAsyncThunk(
  'region/getRegionByIdThunk',
  async (id: string | number, thunkAPI) => {
    const response = await regionService.getById(id);
    return response.data;
  },
);
